module.exports = __webpack_public_path__ + "static/media/6.45e8e024.png";